import { createFileRoute } from '@tanstack/react-router';
import { insightsQueryKeys } from 'hooks/insights/query-keys';
import { InsightsCollectionSkeleton } from 'pages/insights-collection/components/skeleton';
import { queryClient } from 'providers/react-query';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';
import { getCollection } from 'services/strapi/strapi';

const InsightsCollection = lazy(() => import('pages/insights-collection'));

export const Route = createFileRoute('/_authenticated/_main/insights/collection/$collectionId')({
  loader: ({ params }) => {
    void queryClient.prefetchQuery({
      queryKey: insightsQueryKeys.collection({ id: params.collectionId }),
      queryFn: ({ signal }) => getCollection({ id: params.collectionId, signal }),
    });
  },
  component: InsightsCollectionWrapper,
});

function InsightsCollectionWrapper(): JSX.Element {
  return (
    <Suspense fallback={<InsightsCollectionSkeleton />}>
      <InsightsCollection />
    </Suspense>
  );
}
